import styled from 'styled-components';
import getAlignment from 'utils/getAlignment';

const RichTextCtaContainer = styled.div`
  margin: 30px auto;
  display: block;
  width: max-content;
  ${({ alignDesktop, alignMobile }) => {
    if (alignDesktop || alignMobile) {
      const alignValue = alignDesktop || alignMobile;
      const { flexAlignment } = getAlignment(alignValue);

      return `
        margin: 30px 0;
        display: flex;
        align-items: ${flexAlignment};
        `;
    }
  }};

  @media (max-width: 767px) {
    margin: 20px 0;
    align-self: ${({ alignDesktop, alignMobile }) => {
      if (alignDesktop || alignMobile) {
        if (alignMobile) {
          const { flexAlignment } = getAlignment(alignMobile);

          return `
            align-items: ${flexAlignment};`;
        }
      }
    }}
`;

export { RichTextCtaContainer };
